import React from "react";
import { VlmFilterType } from "./vlmFilters";

/**
 * Put the DoubleTake tiles back on "Filtered Queue" whenever the operator
 * applies new filters. A new filter set is a new queue: keeping "Likely FP"
 * (or any other tile) highlighted across it left the tile lit over a list the
 * operator did not ask for, once the fetch refreshed the table.
 *
 * - `fetchingFilteredData` turns true only for an operator-applied server
 *   filter (Filter by menu, filter drawer Apply, has-video toggle), never for
 *   the background refresh.
 * - `detectionType` / `outcomeFilterType` are the client-side dropdowns. Their
 *   first value is the page's starting state, not a change, so it is skipped.
 */
export const useResetVlmFilterOnNewFilters = ({
  fetchingFilteredData,
  detectionType,
  outcomeFilterType,
  setVlmFilterType,
}: {
  fetchingFilteredData: boolean;
  detectionType: string;
  outcomeFilterType: string;
  setVlmFilterType: React.Dispatch<React.SetStateAction<VlmFilterType>>;
}): void => {
  React.useEffect(() => {
    if (fetchingFilteredData) {
      setVlmFilterType("Filtered Queue");
    }
  }, [fetchingFilteredData, setVlmFilterType]);

  const isFirstRender = React.useRef(true);
  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setVlmFilterType("Filtered Queue");
  }, [detectionType, outcomeFilterType, setVlmFilterType]);
};
